import * as React from "react";

type LangContextValue = {
  langEn: boolean;
  setLangEn: React.Dispatch<React.SetStateAction<boolean>>;
  toggleLang: () => void;
};

const LangContext = React.createContext<LangContextValue | undefined>(undefined);

type LangProviderProps = {
  children: React.ReactNode;
};

export const LangProvider: React.FC<LangProviderProps> = ({ children }) => {
  const [langEn, setLangEn] = React.useState(true);
  const toggleLang = () => setLangEn((prev) => !prev);

  return (
    <LangContext.Provider value={{ langEn, setLangEn, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const context = React.useContext(LangContext);
  if (!context) {
    throw new Error("useLang must be used within LangProvider");
  }
  return context;
};
